import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, TransitionGroup as _TransitionGroup, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "c-search-container container-wide q-pb-xl q-pt-md" }
const _hoisted_2 = { class: "row q-col-gutter-y-xl q-col-gutter-x-md" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-sm-4 col-md-3 col-lg-2"
}
const _hoisted_4 = ["data-index"]
const _hoisted_5 = {
  key: 0,
  class: "col-12 text-center q-my-md",
  style: {"margin-bottom":"3rem"}
}
const _hoisted_6 = { class: "q-py-xl" }
const _hoisted_7 = { class: "flex column q-gutter-y-xl" }
const _hoisted_8 = {
  key: 1,
  class: "col-12 text-center",
  style: {"margin-bottom":"3rem"}
}
const _hoisted_9 = ["data-index"]

import AdvertCard from 'src/apps/adverts/components/AdvertCard.vue'
import {useSearchStore} from 'src/apps/search/store'
import {computed, onMounted, ref} from 'vue'
import {useQuasar} from 'quasar'
import VehicleSearchAd from 'src/apps/ads/components/VehicleSearchAd.vue'
import ActiveFilterBadges from 'components/adverts/ActiveFilterBadges.vue'
import {useMainStore} from 'stores/main'
import {useSubscriptionStore} from 'src/apps/subscription/store'
import {createSearchAgent} from 'src/apps/search/helpers'
import {useRouter} from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleSearch',
  setup(__props) {

const mainStore = useMainStore()
const searchStore = useSearchStore()
const subStore = useSubscriptionStore()
const init = ref(false)
const $q = useQuasar()
const $router = useRouter()

onMounted(() => {
  init.value = true
})

function createSearchAgentClick() {
  createSearchAgent($q, mainStore, subStore, searchStore.filterData, $router)
}

const loadingCount = computed(() => {
  if (!(searchStore.searchLoading && init.value)) return 0
  return $q.screen.lt.sm ? 3 : 12
})

function onEnter(ele) {
  ele.style.transitionDelay = `${ele.dataset.index * 0.03}s`
}

const adPositions = computed(() => {
  const adCount = searchStore.vehicleSearchAds?.length ?? 0 // Number of ads to display
  const adsPerInterval = 12 // Interval between ads
  const skipItems = 3
  const positions: number[] = []

  for (let adIndex = 0; adIndex < adCount; adIndex++) {
    // Calculate the position for each ad, independent of items.length
    const position = skipItems + adIndex * adsPerInterval
    positions.push(position)
  }

  return positions
})


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchStore).searchResults.vehicle?.items, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.uuid
        }, [
          (adPositions.value.indexOf(i) !== -1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(VehicleSearchAd, {
                  pos: adPositions.value.indexOf(i)
                }, null, 8, ["pos"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "col-12 col-sm-4 col-md-3 col-lg-2",
            "data-index": i
          }, [
            _createVNode(AdvertCard, { data: item }, null, 8, ["data"])
          ], 8, _hoisted_4)
        ], 64))
      }), 128)),
      (
        !_unref(searchStore).searchLoading &&
        _unref(searchStore).searchResults.vehicle?.items?.length === 0
       )
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-h4 q-mb-sm" }, " Leider gibt es noch kein passendes Fahrzeug. ", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "q-mb-md" }, " Erhalte eine Benachrichtigung wenn dein Traum Fahrzeug mit diesen Filtern zum Verkauf steht ", -1)),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_btn, {
                      rounded: "",
                      "no-caps": "",
                      outline: "",
                      unelevated: "",
                      onClick: createSearchAgentClick
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" Suchauftrag erstellen ")
                      ])),
                      _: 1,
                      __: [1]
                    })
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-h4" }, "Oder reduziere deine Filter", -1)),
                  _createVNode(ActiveFilterBadges, {
                    modelValue: _unref(searchStore).filterData,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchStore).filterData) = $event)),
                    "include-search": "",
                    removable: "",
                    class: "justify-center"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]))
        : (
        !_unref(searchStore).searchLoading &&
        _unref(searchStore).searchResults.vehicle?.items?.length &&
        !_unref(searchStore).hasMorePages
    )
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "q-mb-md" }, " Nichts dabei? Erhalte eine Benachrichtigung bei neuen Inseraten. ", -1)),
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  rounded: "",
                  "no-caps": "",
                  outline: "",
                  unelevated: "",
                  onClick: createSearchAgentClick
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Suchauftrag erstellen ")
                  ])),
                  _: 1,
                  __: [5]
                })
              ])
            ]))
          : _createCommentVNode("", true),
      (_unref(searchStore).searchLoading)
        ? (_openBlock(), _createBlock(_TransitionGroup, {
            key: 2,
            name: "fade",
            css: true,
            onEnter: onEnter
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loadingCount.value, (i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "c-advert-placeholder col-12 col-sm-4 col-md-3 col-lg-2",
                  "data-index": i
                }, [
                  _createVNode(AdvertCard, { loading: true })
                ], 8, _hoisted_9))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})